import { DefaultLinkModel } from "@projectstorm/react-diagrams";

export default class StopLinkModel extends DefaultLinkModel {
  constructor() {
    super({
      type: "stop-link", 
      width: 5, 
      color: "red",
    });
  }
}
